import React, { ComponentType, SVGProps } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

interface PieChartComponentProps {
  data: any[];
  title?: string;
  icon?: React.ReactNode;
}

const PieChartComponent = ({ data, title, icon }: PieChartComponentProps) => {
  type TooltipPayload = ReadonlyArray<any>;

  type Coordinate = {
    x: number;
    y: number;
  };

  type PieSectorData = {
    percent?: number;
    name?: string | number;
    midAngle?: number;
    middleRadius?: number;
    tooltipPosition?: Coordinate;
    value?: number;
    paddingAngle?: number;
    dataKey?: string;
    payload?: any;
    tooltipPayload?: ReadonlyArray<TooltipPayload>;
  };

  type GeometrySector = {
    cx: number;
    cy: number;
    innerRadius: number;
    outerRadius: number;
    startAngle: number;
    endAngle: number;
  };

  type PieLabelProps = PieSectorData &
    GeometrySector & {
      tooltipPayload?: any;
    };

  const RADIAN = Math.PI / 180;
  const COLORS = ["#c8ff00", "#58d42a", "#00b24b", "#deff00"];

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    outerRadius,
    percent,
    name,
  }: PieLabelProps) => {
    const radius = outerRadius * 1.1;
    const x = cx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
    const y = cy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="black"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        <tspan>{name}</tspan>
        <tspan x={x} dy="1.2em">{`(${((percent ?? 0) * 100).toFixed(
          0,
        )}%)`}</tspan>
      </text>
    );
  };

  return (
    <div>
      {/* Title */}
      {title && (
        <div className="w-full -mb-8 flex items-center justify-center space-x-4 text-2xl font-bold text-black">
          {icon}
          <span className="mb-4">{title}</span>
        </div>
      )}
      {/* Chart */}
      <div className="w-full h-[480px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart margin={{ top: 10, right: 10, bottom: 10, left: 10 }}>
            <Pie
              data={data}
              innerRadius="40%"
              outerRadius="70%"
              fill="#8884d8"
              stroke="none"
              dataKey="value"
              labelLine
              label={renderCustomizedLabel}
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${entry.name}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PieChartComponent;
